import { BindableAttrValue } from '@mui/toolpad-core';
import { ensureSuffix } from '@mui/toolpad-utils/strings';
import { Maybe } from '../../utils/types';
import { Authentication, RestConnectionParams } from './types';
import { MOVIES_API_DEMO_URL } from '../demo';

export const HTTP_NO_BODY = new Set(['GET', 'HEAD']);

export function getAuthenticationHeaders(auth: Maybe<Authentication>): [string, string][] {
  if (!auth) {
    return [];
  }

  switch (auth.type) {
    case 'basic':
      return [
        [
          'Authorization',
          `Basic ${Buffer.from(`${auth.user}:${auth.password}`, 'utf-8').toString('base64')}`,
        ],
      ];
    case 'bearerToken':
      return [['Authorization', `Bearer ${auth.token}`]];
    case 'apiKey':
      return [[auth.header, auth.key]];
    default:
      throw new Error(`Unsupported authentication type "${(auth as Authentication).type}"`);
  }
}

export function parseBaseUrl(baseUrl: string): URL {
  const parsedBase = new URL(baseUrl);
  parsedBase.pathname = ensureSuffix(parsedBase.pathname, '/');
  parsedBase.search = '';
  parsedBase.hash = '';
  return parsedBase;
}

export function getDefaultUrl(connection?: RestConnectionParams | null): BindableAttrValue<string> {
  const baseUrl = connection?.baseUrl;

  return baseUrl ? '' : MOVIES_API_DEMO_URL;
}
